module.exports = __webpack_public_path__ + "media/images/details__prizeBox__season__second-3dbf0e57d2243264c3d41f4ada5eca7b.png";